import React from 'react';
import { Link } from 'react-router-dom';
import Serviceimg01 from '../../assets/images/about_service_1.webp';
import { siteCopy } from '../../content/siteCopy';

const Servicesec = () => {
  const { overview } = siteCopy.aboutUs;

  return (
    <>
      <section className="row_am service_section about_service">
        <div className="container">
          <div className="row service_blocks">
            <div className="col-md-6">
              <div
                className="service_text"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div className="title_badge">
                  <span>{overview.badge}</span>
                </div>
                <h2>{overview.title}</h2>
                <p>{overview.body}</p>
                <ul className="feature_list">
                  {overview.bullets.map((item) => (
                    <li key={item}>
                      <div className="icon">
                        <span>
                          <i className="icofont-check-circled" />
                        </span>
                      </div>
                      <div className="text">
                        <p>{item}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="btn_block">
                  <Link to={overview.ctaTo} className="btn puprple_btn ml-0">
                    {overview.ctaLabel}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="inner_block rotate_left"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div className="img">
                  <img src={Serviceimg01} alt="Noor app: explore modules and daily tools" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Servicesec;
